import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, ReactElement } from 'react';
import { S_Checkbox } from '../../../../../../../design/inputs/checkbox/S_Checkbox';

interface IProps {
  checked: boolean;
  onChange(value: boolean): void;
}

export const ProjectPickerSelectAllOption = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    props.onChange(e.target.checked);
  };

  return (
    <S_Checkbox
      id='project-picker-select-all'
      label={t('select_all')}
      onChange={handleChange}
      checked={props.checked}
    />
  );
});
